var map = {
	"./en/bio.ts": [
		99366,
		9366
	],
	"./en/common.ts": [
		37841,
		7841
	],
	"./en/my.ts": [
		65922,
		5922
	],
	"./en/priority.ts": [
		92736,
		2736
	],
	"./es/bio.ts": [
		78889,
		8889
	],
	"./es/common.ts": [
		7900,
		7900
	],
	"./es/my.ts": [
		90867,
		867
	],
	"./es/priority.ts": [
		18257,
		8257
	],
	"./index.ts": [
		50814
	],
	"./ko/bio.ts": [
		65307,
		5307
	],
	"./ko/common.ts": [
		58306,
		8306
	],
	"./ko/my.ts": [
		8505,
		8505
	],
	"./ko/priority.ts": [
		76179,
		6179
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 89639;
module.exports = webpackAsyncContext;